module.exports = __webpack_public_path__ + "img/biren.2e2ce36e.png";